import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { graphql } from '@apollo/client/react/hoc'
import { flowRight } from 'lodash'
import { graphqlCurrentUserCached } from 'lib/utils/store/currentUser'

import ActionLogic from 'components/Util/ActionLogic'

import calculateFuelConsumptionMutation from 'graphql/event/calculateConsumption.gql'
import getVehicleProfileView from 'graphql/view/getVehicleProfileView.gql'

const VehicleFuelConsumptionLogic = ({ children, initState, onMount, calculateFuelConsumptionMutation, currentUser }) => {
    const calculateFuelConsumption = useCallback(async (actionLogic, eventId, mileage, vehicleId, save) => {
        return actionLogic.callMutation(calculateFuelConsumptionMutation, {
            variables: {
                eventId: eventId,
                mileage: mileage,
                saveConsumptionData: save,
            },
            refetchQueries: [{
                query: getVehicleProfileView,
                variables: {
                    vehicleId: vehicleId,
                    userId: currentUser.me.id,
                },
            }],
            awaitRefetchQueries: true,
        })
    }, [calculateFuelConsumptionMutation, currentUser])

    const getRenderProps = useCallback((actionLogic) => {
        return {
            ...actionLogic,
            calculateFuelConsumption: (...args) => calculateFuelConsumption(actionLogic, ...args),
        }
    }, [calculateFuelConsumption])

    const handleMount = useCallback((actionLogic) => {
        onMount && onMount(getRenderProps(actionLogic))
    }, [getRenderProps, onMount])

    return (
        <ActionLogic initState={initState} onMount={handleMount}>
            {(actionLogic) => children(getRenderProps(actionLogic))}
        </ActionLogic>
    )
}

VehicleFuelConsumptionLogic.propTypes = {
    children: PropTypes.func.isRequired,
    ...ActionLogic.propTypes,
}

export default flowRight(
    graphql(calculateFuelConsumptionMutation, { name: 'calculateFuelConsumptionMutation' }),
    graphqlCurrentUserCached,
)(VehicleFuelConsumptionLogic)
